import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { User, UsersTableDataType } from "@/types/index";
import { usersColumns } from "./columns";
import Filters from "./filters";
import { useEffect } from "react";
import UserForm from "../create-user";

export default function UsersTable({ usersData, refreshUsers }: { usersData: User[], refreshUsers: () => void }) {
    const { table, setData } = useTanStackTable<User>({
        tableData: usersData,
        columnConfig: usersColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });

    useEffect(() => {
        setData(usersData);
    }, [usersData, setData]);

    return (
        <div className="mt-14">
            <Filters
                table={table}
                filterOptions={{
                    status: [
                        { value: "active", label: "Active" },
                        { value: "inactive", label: "Inactive" },
                    ],
                    role: [
                        { value: "admin", label: "Admin" },
                        { value: "user", label: "User" },
                    ],
                }}
                modalContent={<UserForm refreshUsers={refreshUsers} />}
                title="Users"
            />
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} />
            <TablePagination table={table} className="py-4" />
        </div>
    );
}
